import store from "@/store";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/home",
    name: "Home2",
    component: Home,
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import(/* webpackChunkName: "projects" */ "../views/Projects.vue"),
  },
  {
    path: "/mytimelog",
    name: "MyTimelog",
    component: () => import(/* webpackChunkName: "mytimelog" */ "../views/MyTimelog.vue"),
  },
  {
    path: "/manage/users",
    name: "ManageUsers",
    component: () => import(/* webpackChunkName: "manageusers" */ "../views/manage/Users.vue"),
  },
  {
    path: "/manage/settings",
    name: "ManageSettings",
    component: () => import(/* webpackChunkName: "managesettings" */ "../views/manage/Settings.vue"),
  },
  {
    path: "/dashboard/adminreports",
    name: "AdminReports",
    component: () => import(/* webpackChunkName: "manageusers" */ "../views/dashboard/AdminReports.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/ticketprojects",
    name: "TicketProjects",
    component: () => import(/* webpackChunkName: "projects" */ "../views/TicketProjects.vue"),
  },
  {
    path: "/myticketlog",
    name: "MyTicketlog",
    component: () => import(/* webpackChunkName: "myticketlog" */ "../views/MyTicketlog.vue"),
  },
  {
    path: "/reports/general",
    name: "GeneralReport",
    component: () => import(/* webpackChunkName: "generalReport" */ "../views/reports/GeneralReport.vue"),
  },
  {
    path: "/reports/advanced",
    name: "AdvancedReport",
    component: () => import(/* webpackChunkName: "advancedReport" */ "../views/reports/AdvancedReport.vue"),
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const auth = store.getters["authStore/isTokenActive"];
  console.debug("route", { auth, from: from.path, to: to.path });

  return next();
});

export default router;
